import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axiosInstance from "../../../api/axiosInstance";

export default function AddAdjustment({ drugs, onClose }) {
  const [batches, setBatches] = useState([]);
  const [form, setForm] = useState({
    drug_id: "", batch_id: "", movement_type: "adjustment",
    quantity: "", notes: "",
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const updated = { ...form, [e.target.name]: e.target.value };
    if (e.target.name === "drug_id") updated.batch_id = "";
    setForm(updated);
  };

  useEffect(() => {
    if (form.drug_id) {
      axiosInstance.get(`getBatchesByDrug/${form.drug_id}`)
        .then(res => setBatches(res.data.data || []))
        .catch(() => setBatches([]));
    } else {
      setBatches([]);
    }
  }, [form.drug_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.drug_id || !form.quantity || !form.movement_type) {
      return Swal.fire("Validation", "Drug, type and quantity are required", "warning");
    }
    setSaving(true);
    try {
      await axiosInstance.post("addStockMovement", form);
      Swal.fire("Success", "Stock movement recorded", "success");
      onClose();
    } catch {
      Swal.fire("Error", "Failed to record movement", "error");
    } finally {
      setSaving(false);
    }
  };

  const isNegative = ["stock_out", "write_off"].includes(form.movement_type);

  return (
    <div className="card">
      <div className="card-header bg-white p-3 d-flex align-items-center">
        <button className="btn btn-sm btn-light me-3" onClick={onClose}>
          <i className="ti ti-arrow-left" /> Back
        </button>
        <h5 className="mb-0">Manual Stock Adjustment</h5>
      </div>
      <div className="card-body" style={{ maxWidth: 600 }}>
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Drug <span className="text-danger">*</span></label>
              <select name="drug_id" value={form.drug_id} onChange={handleChange} required className="form-control">
                <option value="">-- Select Drug --</option>
                {drugs.map(d => <option key={d.id} value={d.id}>{d.name} (Qty: {d.quantity})</option>)}
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Batch (optional)</label>
              <select name="batch_id" value={form.batch_id} onChange={handleChange} className="form-control" disabled={!form.drug_id}>
                <option value="">-- No Specific Batch --</option>
                {batches.map(b => (
                  <option key={b.id} value={b.id}>{b.batch_number} (Rem: {b.quantity_remaining})</option>
                ))}
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Movement Type <span className="text-danger">*</span></label>
              <select name="movement_type" value={form.movement_type} onChange={handleChange} required className="form-control">
                <option value="adjustment">Adjustment</option>
                <option value="write_off">Write-off (Expired/Damaged)</option>
                <option value="stock_in">Stock In</option>
                <option value="stock_out">Stock Out</option>
                <option value="return">Patient Return</option>
                <option value="transfer">Transfer</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Quantity <span className="text-danger">*</span>
                {isNegative && <span className="text-danger ms-1">(will be deducted)</span>}
              </label>
              <input
                type="number" name="quantity" value={form.quantity}
                onChange={handleChange} required min="1"
                className="form-control"
              />
            </div>
            <div className="col-12">
              <label className="form-label">Notes / Reason</label>
              <textarea name="notes" value={form.notes} onChange={handleChange} rows={3} className="form-control" placeholder="e.g. Damaged stock write-off, inventory count correction..." />
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 mt-4">
            <button type="button" className="cancelText" onClick={onClose}>Cancel</button>
            <button type="submit" className="bgBtn" disabled={saving}>{saving ? "Saving..." : "Record Movement"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
